module.exports = __webpack_public_path__ + "img/symbol_4.ae568cd3.png";